import Select from '@ps/payscale-design/lib/select';
import '@ps/payscale-design/lib/select/style/index.scss';
import '@ps/payscale-design/lib/input/style/index.scss'; // for pxl-form-control

export { Select as PXLSelect};
export default Select;



// WEBPACK FOOTER //
// ./src/components/PXL/pxlSelect.ts